/**
 * @generated SignedSource<<53db6b9b8325d82d9458f01a4b38e0c8>>
 * @relayHash a54c42019b1be362c928d3e3faa7a136
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 168f7f271f058112aec794bad9bb8366fc486f56bc6768c58830d75f6beaf808

import type { ConcreteRequest, Query } from 'relay-runtime';
export type LeftPanelAdministrationHomeLeftPanelAdministrationQuery$variables = Record<PropertyKey, never>;
export type LeftPanelAdministrationHomeLeftPanelAdministrationQuery$data = {
  readonly isSiteAdmin: boolean | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined>;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type LeftPanelAdministrationHomeLeftPanelAdministrationQuery = {
  response: LeftPanelAdministrationHomeLeftPanelAdministrationQuery$data;
  variables: LeftPanelAdministrationHomeLeftPanelAdministrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "LeftPanelAdministrationHomeLeftPanelAdministrationQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LeftPanelAdministrationHomeLeftPanelAdministrationQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a54c42019b1be362c928d3e3faa7a136",
    "id": "168f7f271f058112aec794bad9bb8366fc486f56bc6768c58830d75f6beaf808",
    "metadata": {},
    "name": "LeftPanelAdministrationHomeLeftPanelAdministrationQuery",
    "operationKind": "query",
    "text": "query LeftPanelAdministrationHomeLeftPanelAdministrationQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin}"
  }
};
})();

(node as any).hash = "aceb23ec6ded7e3d11e23600ea32ef16";

export default node;
